// import i18n from '../i18n';

export const loaderColor = '#BA2127';
export const loaderColorTgGreen = '#81C43B';
export const loaderColorTgBlue = '#0EC0ED';
export const loaderSize = '1.5em';
export const loaderSizeSm = '1em';
export const loaderSizeXS = '0.5em';
export const lazyImage =
  'https://e6golf-qa-assets.imgix.net/shared/store/e6golf-web-store-header@3x.jpg?blur=200&w=400&h=400&fit=crop';
export const lazyProductImage =
  'https://e6golf-qa-assets.imgix.net/uploads/clubhouses/branding/e6Connect_logo_1.jpg?blur=70&w=300?crop=true';
export const lazyProductImageTG =
  'https://e6golf-assets.imgix.net/products/TG_logo.png?blur=70&w=300?crop=true';
export const lazyProfileImage =
  'https://e6golf-qa-assets.imgix.net/shared/player-art/chipped.jpg?h=200&w=200&fit=crop';
export const defaultProductImage = `https://picsum.photos/500/300?image=${1 * 5 + 10}`;
export const limitedGameModes = ['ClosestToPin', 'LongestDrive'];
export const limitedAltModes = ['Blackout', 'Solaro', 'Darts'];
export const teamModes = ['Scramble', 'scramble', 'Best Ball', 'bestball', 'best_ball', 'BestBall'];
export const scoreCardModes = [
  'Stroke Play',
  'strokeplay',
  'stroke play',
  'stroke_play',
  'StrokePlay',
  'strokePlay',
  'Scramble',
  'scramble',
  'Best Ball',
  'BestBall',
  'bestball',
  'best ball',
  'best_ball',
  'Stableford',
  'stableford',
];
export const attemptOptions = [
  'Closest to the Pin',
  'ClosestToPin',
  'Long Drive',
  'LongestDrive',
  'longestdrive',
  'LongDrive',
  'Long Drive - World Series',
  'LongDriveWorldSeries',
  'longdriveworldseries',
  'Blackout',
  'Solaro',
  'Darts',
  'Solaro - Blackout',
  'Henyett - Darts',
];
export const genderOptions = [
  { text: 'Male', value: 'male' },
  { text: 'Female', value: 'female' },
  { text: 'Undisclosed', value: 'undisclosed' },
];
export const handOptions = [
  { text: 'Right', value: 'right' },
  { text: 'Left', value: 'left' },
];
export const clubEmailOptions = [
  { key: 'no', value: false },
  { key: 'yes', value: true },
];
export const physicalProductTypes = ['simulators', 'tgMini', 'replacementItem'];
export const miniGamesList = [
  'Blackout',
  'Solaro',
  'Darts',
  'Solaro - Blackout',
  'Henyett - Darts',
  'Long Drive - World Series',
];
export const coursesNotIncludedList = [
  'Henyett - Darts',
  'Darts',
  'Blackout',
  'Solaro',
  'Solaro - Blackout',
  'Battle Stations',
  'Long Drive Range',
  'Practice Area Targets',
  'T-Shotz K.C.',
];
export const desktopType = 'Desktop';
export const mobileType = 'Mobile';
export const courseSelectHeaders = [
  { text: '', align: 'left', value: 'imageURL', sortable: false },
  { text: 'Name', align: 'left', value: 'name', sortable: true },
  { text: 'Par', align: 'center', value: 'mensPar', sortable: true },
  {
    text: 'Yardage',
    align: 'center',
    value: 'teeLevels[0].footage',
    sortable: true,
  },
];
export const clubmemberPermissions = ['ADMIN', 'METRICS', 'EMAIL', 'SEASONS'];
export const userPermissions = [
  'USER',
  'LIMITEDUSER',
  'ADMIN',
  'RESELLER',
  'RESELLEREXEMPT',
  'OEMSELLER',
  'ACCOUNTING',
  'DEV',
  'SALES',
  'SUPPORT',
  'ACTIVATIONS',
  'MARKETING',
  'SEASONS',
  'CLUBHOUSE',
  'TRUSIMAPI',
];

// shaft_flex enum [x, s, r, a l]
export const shaftFlexOptions = [
  {
    text: '',
    value: '',
  },
  {
    text: 'X',
    value: 'x',
  },
  {
    text: 'S',
    value: 's',
  },
  {
    text: 'R',
    value: 'r',
  },
  {
    text: 'A',
    value: 'a',
  },
  {
    text: 'L',
    value: 'l',
  },
];
// club_tag enum[draw, fade, neutral, half_swing, three_quarter_swing, chip, punch, flop]
export const clubTagOptions = [
  {
    text: '',
    value: '',
  },
  {
    text: 'Draw',
    value: 'draw',
  },
  {
    text: 'Fade',
    value: 'fade',
  },
  {
    text: 'Neutral',
    value: 'neutral',
  },
  {
    text: 'Half Swing',
    value: 'half_swing',
  },
  {
    text: 'Three Quarter Swing',
    value: 'three_quarter_swing',
  },
  {
    text: 'Chip',
    value: 'chip',
  },
  {
    text: 'Punch',
    value: 'punch',
  },
  {
    text: 'Flop',
    value: 'flop',
  },
];
export const stateList = [
  {
    value: 'AL',
    text: 'Alabama',
  },
  {
    value: 'AK',
    text: 'Alaska',
  },
  {
    value: 'AS',
    text: 'American Samoa',
  },
  {
    value: 'AZ',
    text: 'Arizona',
  },
  {
    value: 'AR',
    text: 'Arkansas',
  },
  {
    value: 'CA',
    text: 'California',
  },
  {
    value: 'CO',
    text: 'Colorado',
  },
  {
    value: 'CT',
    text: 'Connecticut',
  },
  {
    value: 'DE',
    text: 'Delaware',
  },
  {
    value: 'DC',
    text: 'District Of Columbia',
  },
  {
    value: 'FM',
    text: 'Federated States Of Micronesia',
  },
  {
    value: 'FL',
    text: 'Florida',
  },
  {
    value: 'GA',
    text: 'Georgia',
  },
  {
    value: 'GU',
    text: 'Guam',
  },
  {
    value: 'HI',
    text: 'Hawaii',
  },
  {
    value: 'ID',
    text: 'Idaho',
  },
  {
    value: 'IL',
    text: 'Illinois',
  },
  {
    value: 'IN',
    text: 'Indiana',
  },
  {
    value: 'IA',
    text: 'Iowa',
  },
  {
    value: 'KS',
    text: 'Kansas',
  },
  {
    value: 'KY',
    text: 'Kentucky',
  },
  {
    value: 'LA',
    text: 'Louisiana',
  },
  {
    value: 'ME',
    text: 'Maine',
  },
  {
    value: 'MH',
    text: 'Marshall Islands',
  },
  {
    value: 'MD',
    text: 'Maryland',
  },
  {
    value: 'MA',
    text: 'Massachusetts',
  },
  {
    value: 'MI',
    text: 'Michigan',
  },
  {
    value: 'MN',
    text: 'Minnesota',
  },
  {
    value: 'MS',
    text: 'Mississippi',
  },
  {
    value: 'MO',
    text: 'Missouri',
  },
  {
    value: 'MT',
    text: 'Montana',
  },
  {
    value: 'NE',
    text: 'Nebraska',
  },
  {
    value: 'NV',
    text: 'Nevada',
  },
  {
    value: 'NH',
    text: 'New Hampshire',
  },
  {
    value: 'NJ',
    text: 'New Jersey',
  },
  {
    value: 'NM',
    text: 'New Mexico',
  },
  {
    value: 'NY',
    text: 'New York',
  },
  {
    value: 'NC',
    text: 'North Carolina',
  },
  {
    value: 'ND',
    text: 'North Dakota',
  },
  {
    value: 'MP',
    text: 'Northern Mariana Islands',
  },
  {
    value: 'OH',
    text: 'Ohio',
  },
  {
    value: 'OK',
    text: 'Oklahoma',
  },
  {
    value: 'OR',
    text: 'Oregon',
  },
  {
    value: 'PW',
    text: 'Palau',
  },
  {
    value: 'PA',
    text: 'Pennsylvania',
  },
  {
    value: 'PR',
    text: 'Puerto Rico',
  },
  {
    value: 'RI',
    text: 'Rhode Island',
  },
  {
    value: 'SC',
    text: 'South Carolina',
  },
  {
    value: 'SD',
    text: 'South Dakota',
  },
  {
    value: 'TN',
    text: 'Tennessee',
  },
  {
    value: 'TX',
    text: 'Texas',
  },
  {
    value: 'UT',
    text: 'Utah',
  },
  {
    value: 'VT',
    text: 'Vermont',
  },
  {
    value: 'VI',
    text: 'Virgin Islands',
  },
  {
    value: 'VA',
    text: 'Virginia',
  },
  {
    value: 'WA',
    text: 'Washington',
  },
  {
    value: 'WV',
    text: 'West Virginia',
  },
  {
    value: 'WI',
    text: 'Wisconsin',
  },
  {
    value: 'WY',
    text: 'Wyoming',
  },
];

export const yearList = [
  2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011, 2010, 2009, 2008, 2007, 2006, 2005,
  2004, 2003, 2002, 2001, 2000, 1999, 1998, 1997, 1996, 1995, 1994, 1993, 1992, 1991, 1990, 1989,
  1988, 1987, 1986, 1985, 1984, 1983, 1982, 1981, 1980, 1979, 1978, 1977, 1976, 1975, 1974, 1973,
  1972, 1971, 1970, 1969, 1968, 1967, 1966, 1965, 1964, 1963, 1962, 1961, 1960, 1959, 1958, 1957,
  1956, 1955, 1954, 1953, 1952, 1951, 1950, 1949, 1948, 1947, 1946, 1945, 1944, 1943, 1942, 1941,
  1940, 1939, 1938, 1937, 1936, 1935, 1934, 1933, 1932, 1931, 1930, 1929, 1928, 1927, 1926, 1925,
  1924, 1923, 1922, 1921, 1920, 1919, 1918, 1917, 1916, 1915, 1914, 1913, 1912, 1911, 1910, 1909,
  1908, 1907, 1906, 1905,
];

// Product Options
export const productTypes = [
  {
    text: 'Purchase',
    value: 'purchase',
  },
  {
    text: 'Subscription',
    value: 'subscription',
  },
  {
    text: 'Consumable',
    value: 'consumable',
  },
];

export const productCategories = [
  {
    text: 'All',
    value: '',
  },
  {
    text: 'Course Content',
    value: 'courseContent',
  },
  {
    text: 'Tracking System',
    value: 'trackingSystem',
  },
  {
    text: 'License Subscription',
    value: 'licenseSubscription',
  },
  {
    text: 'User Permission',
    value: 'userPermission',
  },
  {
    text: 'MOP Content',
    value: 'mopContent',
  },
  {
    text: 'Multi Sport',
    value: 'multiSport',
  },
  {
    text: 'Event Content',
    value: 'eventContent',
  },
  {
    text: 'Apogee',
    value: 'apogee',
  },
  {
    text: 'Simulators',
    value: 'simulators',
  },
  {
    text: 'TruGolf Mini',
    value: 'tgMini',
  },
  {
    text: 'Replacement Item',
    value: 'replacementItem',
  },
];

export const subscriptionProductDelayOptions = [
  { text: '1 Day', value: '1 day' },
  { text: '1 Week', value: '7 days' },
  { text: '10 Days', value: '10 days' },
  { text: '1 Month', value: '1 month' },
  { text: '6 Months', value: '6 months' },
  { text: '1 Year', value: '365 days' },
  { text: '2 Years', value: '730 days' },
];
